/** When given an HTMLElement, this cause a 'reflow' so that its layout is calculated by the browser. This causes the
 * browser to know the element's location for when the subsequent code changes the elements layout, and allows a CSS
 * transition to run. If a 'reflow' does not happen and the same CSS property is changed then the transition will not
 * occur
 */
export function prepareForTransition(htmlElement: HTMLElement) {
  // Call the scrollHeight getter on the element to ensure a reflow has happened, then discard the value using "void".
  void htmlElement.scrollHeight;
}

/** Scrolls the page so that an element is visible, if the element is already visible then no scrolling occurs */
export function scrollIntoViewIfNeeded(
  element: HTMLElement,
  behavior: ScrollBehavior = 'smooth',
  /** The position within the element to scroll to, either its top (start) or bottom (end) - note that "block" refers to how
   * HTML layout works. For western languages, "block" is the vertical direction.
   */
  scrollLocationInBlockDirection?: 'start' | 'end',
) {
  const rect = element.getBoundingClientRect();

  const isInViewport =
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= window.innerHeight &&
    rect.right <= window.innerWidth;

  if (!isInViewport) {
    element.scrollIntoView({
      behavior,
      block: scrollLocationInBlockDirection || 'start',
      inline: 'start',
    });
  }
}
